<template>
  <div>
    <div class="webIndex_change" @click="change_webIndex">
      <img :src="btnUrl" alt="" />
    </div>
    <div class="webIndex" :style="{ display: visbshow }">
      <!-- 广告 -->
      <div class="bgcc_zjx">
        <el-carousel height="120px" :interval="5000">
          <el-carousel-item v-for="(item, index) in bannerImgList" :key="index">
            <img
              :src="item.path"
              style="width: 100%; height: 120px; object-fit: cover"
              alt=""
            />
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- banner资讯+文件公告 -->
      <div class="brund_cast">
        <newsCard ref="infoCard"></newsCard>
        <div class="zjxWarpList">
          <div class="sinfo_list_head overSize">
            <div class="big_title_box">
              <p class="big_title_p">公告资讯</p>
            </div>
            <span
              class="sinfo_list_head_span"
              @click="newPageListTo(columnCode1, '公告资讯')"
              >更多></span
            >
          </div>
          <!-- 复用服务动态 -->
          <div class="sinfo_list_head phoneSize">
            <div class="big_title_box">
              <p
                :class="[
                  smallChoose == index ? 'specil_small_p' : '',
                  'specil_title_p',
                ]"
                v-for="(item, index) in tableList"
                @click="smallChoose = index"
                :key="index"
              >
                {{ item }}
              </p>
            </div>
            <span
              class="sinfo_list_head_span"
              @click="phonePageListTo(smallChoose)"
              >更多></span
            >
          </div>
          <!-- 复用服务动态 -->
          <infoList
            v-show="smallChoose == 0"
            @activeList="activeList($event, '公告资讯')"
            :column_code="columnCode1"
            :page_size="7"
          ></infoList>
          <infoList
            v-show="smallChoose == 1"
            @activeList="activeList($event, '服务动态')"
            :column_code="columnCode2"
            :page_size="7"
          ></infoList>
          <infoList
            v-show="smallChoose == 2"
            @activeList="activeList($event, '会员留言')"
            :column_code="'会员留言'"
            :page_size="7"
          ></infoList>
          <!-- 复用服务动态 -->
        </div>
      </div>
      <!-- 服务动态 + 会议报名 -->
      <div class="active_meeting">
        <div class="info_list_zjx">
          <div class="sinfo_list_head">
            <div class="big_title_box">
              <p class="big_title_p">服务动态</p>
            </div>
            <span
              class="sinfo_list_head_span"
              @click="newPageListTo(columnCode2, '服务动态')"
              >更多></span
            >
          </div>
          <infoList
            @activeList="activeList($event, '服务动态')"
            :column_code="columnCode2"
            :page_size="7"
          >
          </infoList>
        </div>

        <div class="info_list_zjx" style="border-left: 1px dashed #ccc">
          <div class="sinfo_list_head">
            <div class="big_title_box">
              <p class="big_title_p">会员留言</p>
            </div>
            <span
              class="sinfo_list_head_span"
              @click="newPageListTo('会员留言', '会员留言')"
              >更多></span
            >
          </div>
          <infoList
            @activeList="activeList($event, '会员留言')"
            :column_code="'会员留言'"
            :page_size="7"
          >
          </infoList>
        </div>

        <div class="zjxRightView" v-if="false">
          <div class="zjxRightView_left">
            <div class="sinfo_list_head">
              <div class="big_title_box">
                <p class="big_title_p">业务平台</p>
              </div>
            </div>

            <serviceTitle>
              <template #left>
                <div class="serviceOut">
                  <p
                    v-for="(item, index) in titlemuList"
                    @click="chooseTitleLand(item, index)"
                    :class="titleIndex == index ? 'activeChoose' : ''"
                    :key="index"
                  >
                    {{ item.name }}
                  </p>
                </div>
              </template>
              <template #right>
                <span class="sinfo_list_head_span" @click="activitiesMore"
                  >更多></span
                >
              </template>
            </serviceTitle>

            <div
              style="
                display: flex;
                justify-content: space-between;
                padding: 0 20px 20px;
              "
            >
              <div
                class="servePaltorm"
                v-for="(item, index) in serviceList"
                :key="index"
                @click="toLink(item)"
              >
                <img
                  :src="item.img"
                  style="width: 100%; height: 98px; object-fit: cover"
                  alt=""
                />
                <div class="servePaltorm_text">
                  <div style="height: 40px">
                    <p class="p1">{{ item.meetingName }}</p>
                  </div>
                  <div style="height: 40px">
                    <p class="p2">{{ item.meetingTime }}</p>
                  </div>
                  <div style="height: 25px">
                    <p class="p2">{{ item.provinceCity }}</p>
                  </div>
                </div>
                <div class="servePaltorm_live">
                  <ShowTips v-if="item.statusName" :message="item.statusName" />
                  <img
                    v-if="setImgShow(item) === true"
                    src="../../assets/img/webIndex/alive.png"
                    style="height: 20px"
                    alt=""
                  />
                  <img
                    v-else-if="setImgShow(item) === false"
                    src="../../assets/img/webIndex/aCourse.png"
                    style="height: 20px"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 业务平台 -->
      <div class="">
        <div
          class="normalFlex courseFlex"
          style="border-bottom: 1px solid #d8d8d8"
        >
          <div class="normalFlex">
            <div class="normalFlex">
              <span class="zjx_course_span_1"></span>
              <span class="zjx_course_span_2"></span>
              <p class="zjx_course_p">业务平台</p>
            </div>
            <div class="overSize">
              <div class="sepcilLandList_new">
                <p
                  v-for="(item, index) in titlemuList"
                  @click="chooseTitleLand(item, index)"
                  :class="titleIndex == index ? 'activeChoose' : ''"
                  :key="index"
                >
                  {{ item.name }}
                </p>
              </div>
            </div>
          </div>

          <div style="display: flex; align-items: center">
            <el-tooltip
              class="item"
              effect="dark"
              content="地方、行业协会，央企总部"
              placement="bottom"
            >
              <p
                style="
                  margin-right: 20px;
                  color: #3c66ae;
                  cursor: pointer;
                  font-size: 18px;
                  font-weight: 600;
                "
                @click="openOutLink"
              >
                推荐单位登录
              </p>
            </el-tooltip>
            <p class="courseFlex_right" @click="activitiesMore">更多></p>
          </div>
        </div>

        <div class="phoneSize">
          <div
            class="normalFlex sepcilLandList"
            style="justify-content: space-evenly"
          >
            <p
              v-for="(item, index) in titlemuList"
              @click="chooseTitleLand(item, index)"
              :class="titleIndex == index ? 'activeChoose' : ''"
              :key="index"
            >
              {{ item.name }}
            </p>
          </div>
        </div>
        <div class="newGrid">
          <div
            v-for="(item, index) in serviceList"
            class="classFlex_view"
            :key="index"
            @click="toLink(item)"
          >
            <img v-show="item.img" :src="item.img" alt="" />
            <div class="servePaltorm_text">
              <div style="height: 50px">
                <p class="p1">{{ item.meetingName }}</p>
              </div>
              <div style="height: 30px">
                <p class="p2">{{ item.meetingTime }}</p>
              </div>
              <div style="height: 25px">
                <p class="p2">{{ item.provinceCity }}</p>
              </div>
            </div>
            <div class="servePaltorm_live">
              <ShowTips v-if="item.statusName" :message="item.statusName" />
              <img
                v-if="setImgShow(item) === true"
                src="../../assets/img/webIndex/alive.png"
                style="height: 20px"
                alt=""
              />
              <img
                v-else-if="setImgShow(item) === false"
                src="../../assets/img/webIndex/aCourse.png"
                style="height: 20px"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 精品课程 -->
      <div class="">
        <div
          class="normalFlex courseFlex"
          style="border-bottom: 1px solid #d8d8d8"
        >
          <div class="normalFlex">
            <div class="normalFlex">
              <span class="zjx_course_span_1"></span>
              <span class="zjx_course_span_2"></span>
              <p class="zjx_course_p">学习充电</p>
            </div>
            <div class="overSize">
              <!-- <div class="normalFlex sepcilLandList">
							<p v-for="(item,index) in lanmuList" @click="chooseLand(index)"
								:class="chooseIndex == index?'activeChoose':''" :key="index">{{item.name}}</p>
						</div> -->
              <div class="sepcilLandList_new">
                <p
                  v-for="(item, index) in lanmuList"
                  @click="chooseLand(index)"
                  :class="chooseIndex == index ? 'activeChoose' : ''"
                  :key="index"
                >
                  {{ item.name }}
                </p>
              </div>
            </div>
          </div>
          <p class="courseFlex_right" @click="navToVideo" v-show="totalNum > 4">
            更多>
          </p>
        </div>

        <div class="phoneSize">
          <div
            class="normalFlex sepcilLandList"
            style="justify-content: space-evenly"
          >
            <p
              v-for="(item, index) in lanmuList"
              @click="chooseLand(index)"
              :class="chooseIndex == index ? 'activeChoose' : ''"
              :key="index"
            >
              {{ item.name }}
            </p>
          </div>
        </div>
        <div class="newGrid">
          <div
            v-for="(item, index) in courseList"
            class="classFlex_view"
            :key="index"
          >
            <img
              v-show="item.picPath"
              @click="openLink(item)"
              :src="item.picPath"
              alt=""
            />
            <div
              v-show="item.title"
              @click="openLink(item)"
              class="classFlex_title"
            >
              <p class="best_courses_p">{{ item.title }}</p>
              <span class="best_courses_Span">
                <p class="best_courses_p__p1"></p>
                <p class="best_courses_p__p2">
                  {{ item.isVip === 1 ? "限会员免费" : "免费" }}
                </p>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!-- 工程 -->
      <div>
        <div class="normalFlex courseFlex">
          <div class="normalFlex">
            <span class="zjx_course_span_1"></span>
            <span class="zjx_course_span_2"></span>
            <p class="zjx_course_p">精品展示</p>
          </div>
          <div>
            <div class=""></div>
          </div>
        </div>
        <div class="marginBot">
          <el-carousel
            ref="slideCarousel"
            indicator-position="none"
            :height="newHeight + 'px'"
            :autoplay="false"
            style="width: 100%"
          >
            <el-carousel-item v-for="(items, index) in goodShops" :key="index">
              <div class="grestProgrma">
                <div
                  class="grestProgrma_view"
                  v-for="(item, key) in items"
                  @click="showIndexDetail(item)"
                  :key="key"
                >
                  <img :src="item.casePic" alt="" :title="item.description" />
                  <div class="versionDec">
                    <span>{{ item.caseName }}</span>
                    <p>{{ item.description }}</p>
                    <div>更多></div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <!-- 会员数据 -->
      <div>
        <div class="normalFlex courseFlex">
          <div class="normalFlex">
            <span class="zjx_course_span_1"></span>
            <span class="zjx_course_span_2"></span>
            <p class="zjx_course_p">会员分布</p>
          </div>
          <div>
            <div class=""></div>
          </div>
        </div>

        <div style="margin-bottom: 30px">
          <memberDataShow :status="status" />
        </div>
      </div>
      <!-- 联系我们 -->
      <div>
        <div class="normalFlex courseFlex" v-if="contactList.length">
          <div class="normalFlex">
            <span class="zjx_course_span_1"></span>
            <span class="zjx_course_span_2"></span>
            <p class="zjx_course_p">联系我们</p>
          </div>
          <div>
            <div class=""></div>
          </div>
        </div>
        <!-- 复用 -->
        <div class="view_father3">
          <div
            class="flip_wrap"
            v-for="(item, index) in contactList"
            :key="index"
            @click="navToLink(item.link)"
          >
            <div class="flip">
              <div class="new_course_box side front">
                <img :src="item.casePic" alt="" />
                <p>{{ item.caseName }}</p>
              </div>
              <div class="side back" v-html="item.content"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 支持 -->
      <div>
        <div class="normalFlex courseFlex">
          <div class="normalFlex">
            <span class="zjx_course_span_1"></span>
            <span class="zjx_course_span_2"></span>
            <p class="zjx_course_p">支持单位</p>
          </div>
          <div>
            <div class=""></div>
          </div>
        </div>
        <div class="view_father3" style="margin-bottom: 57px">
          <div
            class="course_box"
            v-for="(item, index) in soures_list"
            @click="navToLink(item.link)"
            :key="index"
          >
            <img :src="item.logo" alt="" />
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="leaderIndex" v-show="visbshow === 'none'">
      <img src="../../assets/img/test/bg1.png" alt="" />
      <img src="../../assets/img/test/bg2.png" alt="" />
      <img src="../../assets/img/test/bg3.png" alt="" />
      <img src="../../assets/img/test/bg4.png" alt="" />
      <img src="../../assets/img/test/bg5.png" alt="" />
      <img src="../../assets/img/test/bg6.png" alt="" />
      <img src="../../assets/img/test/bg7.png" alt="" />
      <img src="../../assets/img/test/bg8.png" alt="" />
      <img src="../../assets/img/test/bg9.png" alt="" />
      <img src="../../assets/img/test/bg10.png" alt="" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import newsCard from "./components/newsCard.vue";
import infoList from "./components/infoList.vue";
import serviceTitle from "./components/serviceTitle.vue";
import memberDataShow from "./components/memberDataShow.vue";
import ShowTips from "@/components/showTips/index.vue";
// import zjxCard from './components/zjxCard.vue'
import "../../assets/css/flip.css";
import {
  getNewAwork,
  getIndexBanner,
  getWorkArea,
  getVideoCate,
  getVideoList,
  getIntegralUrl,
} from "../../api/moudles/home.js";
import { touchBanener } from "../../utils/slideBanner.js";
import { getNavList } from "../../api/moudles/user.js";
import { getActivityList } from "@/api/moudles/activities.js";

export default {
  components: {
    newsCard,
    infoList,
    serviceTitle,
    // zjxCard,
    ShowTips,
    memberDataShow,
  },
  data() {
    return {
      meetingDetail: {},
      serviceList: [],
      activitiesLives: "",
      titlemuList: [
        {
          name: "所有分类",
          type: "",
        },

        {
          name: "活动报名",
          type: "1",
        },
        {
          name: "直播",
          type: "2",
        },
      ],
      btnUrl: "",
      videoColumn: "",
      btnUrlfront: require("../../assets/img/test/btn.png"),
      btnUrlBack: require("../../assets/img/test/btnback.jpg"),
      visbshow: "block",
      totalNum: 0,
      secondHeight: "185",
      status: "pc",
      smallChoose: 0,
      chooseIndex: 0,
      titleIndex: 0,
      // 栏目名称
      lanmuList: [],
      tableList: ["公告资讯", "服务动态", "会员留言"],
      tipOne: {
        title: "",
        //titleOne: "2022-3-15 到 2022-4-15",
        //titleTwo: "",
        status: "",
      },
      tipTwo: {
        title: "",
        titleOne: "",
        titleTwo: "",
        status: "",
      },
      courseList: [],
      newHeight: "382",
      bannerImgList: [],
      columnCode1: "",
      columnCode2: "",
      bgcOne: require("../../assets/img/webIndex/acOne.jpg"),
      bgcTwo: require("../../assets/img/webIndex/acTwo.jpg"),
      // bgcOne: 'linear-gradient(90deg, #FA7B81 0%, #FFA281 100%)',
      // bgcTwo: 'linear-gradient(90deg, #E19D47 0%, #DB8A1C 100%)',
      // 精品工程展示
      goodShops: [],
      // 联系我们
      contactList: [],
      // 入会等
      actionList: [
        {
          name: "入会须知",
          path: require("../../assets/img/webIndex/needknow.png"),
        },
        {
          name: "会员注册",
          path: require("../../assets/img/webIndex/register.png"),
        },
        {
          name: "会员登录",
          path: require("../../assets/img/webIndex/login.png"),
        },
        {
          name: "会员校验",
          path: require("../../assets/img/webIndex/check.png"),
        },
      ],
      // 精品课程资讯
      soures_list: [],
      autoplay: true,
      toPath: "videoplay",
      webSiteUrl: "",
    };
  },
  created() {
    this.btnUrl = this.btnUrlfront;
    this.getNavList();
    /**
     * 测试
     */
    // this.getIndexBanner("36bb4a1b-d884-4832-bd09-5891bcddf104");
    // this.getVideoCate();

    // 首次进入token超时验证
    if (localStorage.getItem("tokenTime")) {
      const startDate = localStorage.getItem("tokenTime");
      const endDate = Date.now();
      const timeDifference = endDate - startDate;
      // 2小时等于  毫秒
      if (timeDifference > 60 * 60 * 2 * 1000) {
        // this.$store.commit('user/RESET_INFO')
      }
    }
    this.getActivityList();
  },
  mounted() {
    let newConfig = JSON.parse(localStorage.dynamicConfig);
    if (newConfig.website_url) {
      this.webSiteUrl = newConfig.website_url;
    }

    if (this.$phoneSize()) {
      this.toPath = "phoneVideoplay";
      this.status = "phone";
      this.newHeight = "382";
      this.secondHeight = "330";
      this.$refs.infoCard.setHeight();
    } else {
      this.toPath = "videoplay";
      this.status = "pc";
      this.newHeight = "382";
      this.secondHeight = "185";
      this.$refs.infoCard.resolveHeight();
    }
    window.onresize = () =>
      (() => {
        const screenWidth = window.screen.width;
        if (screenWidth < 760 && this.status != "phone") {
          this.toPath = "phoneVideoplay";
          this.$router.replace({
            name: "phoneIndex",
          });
        }
        if (screenWidth > 760 && this.status != "pc") {
          this.toPath = "videoplay";
          this.$router.replace({
            name: "webIndex",
          });
        }
      })();
    let that = this;
    touchBanener(that);
  },
  computed: {
    setImgShow() {
      return (item) => {
        if (item.isLive) {
          const startDate = new Date(item.meetingStartTime);
          const endDate = new Date(item.meetingEndTime);
          const currentDate = new Date();

          const isWithinRange =
            currentDate >= startDate && currentDate <= endDate;
          return isWithinRange;
        }
        return null;
      };
    },
    ...mapState({
      // 箭头函数可使代码更简练
      userInfo: (state) => state.user.userInfo,
    }),
  },
  methods: {
    openOutLink() {
      window.open("http://203.0.105.80:81/login");
    },
    // 业务活动跳转
    toLink(item) {
      if (item.outUrl) {
        if (item.outUrl.indexOf("http") !== -1) {
          this.$router.push({
            name: "ifirameView",
            params: {
              url: item.outUrl,
              code: item.meetingCode,
            },
          });
        } else {
          if (this.$phoneSize()) {
            if (item.module == "live") {
              this.$router.push({
                name: "ifirameView",
                params: {
                  url: `${this.webSiteUrl}/sub_activities/pages/live/live?id=${item.outUrl}`,
                  code: item.meetingCode,
                },
              });
            } else {
              this.$router.push({
                name: "ifirameView",
                params: {
                  url: `${this.webSiteUrl}/sub_activities/pages/iframeDetail/iframeDetail?id=${item.outUrl}`,
                  code: item.meetingCode,
                },
              });
            }
          } else {
            if (item.module == "live") {
              this.$router.push({
                name: "ifirameView",
                params: {
                  url: `${this.webSiteUrl}/lives/${item.outUrl}`,
                  code: item.meetingCode,
                },
              });
            } else {
              this.$router.push({
                name: "ifirameView",
                params: {
                  url: `${this.webSiteUrl}/activities/${item.outUrl}`,
                  code: item.meetingCode,
                },
              });
            }
          }
        }
      } else {
        // 会议1
        if (item.meetingCode == "22791675424589") {
          window.open("http://123.57.205.192/home/index");
          return;
        }
        // 会议2
        if (item.meetingCode == "44951675671015") {
          window.open("https://jinshuju.net/f/CLq0uQ");
          return;
        }
        if (this.$phoneSize()) {
          this.$router.push({
            name: "phoneActivitiesDetail",
            params: {
              code: item.meetingCode,
            },
          });
        } else {
          this.$router.push({
            name: "activitiesDetail",
            params: {
              code: item.meetingCode,
            },
          });
        }
      }
    },
    change_webIndex() {
      if (this.visbshow == "none") {
        this.visbshow = "block";
        this.btnUrl = this.btnUrlfront;
      } else {
        this.visbshow = "none";
        this.btnUrl = this.btnUrlBack;
      }
    },
    activitiesMore() {
      if (this.$phoneSize()) {
        this.$router.push("./phoneActivitiesList");
      } else {
        this.$router.push("./activitiesList");
      }
    },
    // 获取业务详情列表
    getActivityList() {
      getActivityList({
        data: {
          type: this.activitiesLives,
        },
        success: (res) => {
          if (res.data) {
            const newArr = res.data;
            // newArr
            // .sort((value1, value2) => value1.sort - value2.sort)
            //   .sort((value1, value2) => value1.id - value2.id);
            this.serviceList = newArr.slice(0, 4);
          }
        },
      });
    },

    // 跳转到学习充电
    navToVideo() {
      if (this.$phoneSize()) {
        this.$router.push({
          name: "phoneCourseLearn",
          params: {
            ...this.lanmuList[this.chooseIndex],
            index: this.chooseIndex,
          },
        });
      } else {
        this.$router.push({
          name: "courseLearn",
          params: {
            ...this.lanmuList[this.chooseIndex],
            index: this.chooseIndex,
          },
        });
      }
    },
    // 获取视频列表
    async getVideoList(cate) {
      await getVideoList({
        data: {
          columnCode: this.videoColumn,
          cate,
          pageNo: "1",
          pageSize: "4",
        },
        success: (res) => {
          console.log("视频列表res", res);
          this.courseList = res.data.list;
          this.totalNum = parseInt(res.data.total);
        },
      });
    },
    // 选择视频栏目
    chooseLand(index) {
      this.chooseIndex = index;
      this.getVideoList(this.lanmuList[index].id);
    },
    chooseTitleLand(item, index) {
      this.activitiesLives = item.type;
      this.titleIndex = index;
      this.getActivityList();
    },
    // 从首页进入详情页
    activeList(e, name) {
      localStorage.setItem("columnName", name);
      if (name == "公告资讯") {
        localStorage.setItem("columnCode", this.columnCode1);
      } else if (name == "服务动态") {
        localStorage.setItem("columnCode", this.columnCode2);
      }
    },
    // 公告资讯和服务动态跳转
    newPageListTo(columnCode, name) {
      localStorage.setItem("columnCode", columnCode);
      localStorage.setItem("columnName", name);
      this.$router.push({
        name: "empty",
      });
    },
    // 手机模式跳转
    phonePageListTo(index) {
      if (index == 0) {
        // 公告资讯
        localStorage.setItem("columnCode", this.columnCode1);
        localStorage.setItem("columnName", "公告资讯");
      }
      if (index == 1) {
        // 服务动态
        localStorage.setItem("columnCode", this.columnCode2);
        localStorage.setItem("columnName", "服务动态");
      }
      if (index == 2) {
        // 会员留言
        localStorage.setItem("columnCode", "会员留言");
        localStorage.setItem("columnName", "会员留言");
      }
      this.$router.push({
        name: "phoneEmpty",
      });
    },
    // 打开课程链接
    async openLink(item) {
      const token = this.$store.state.user.token;
      if (item.points > 0 && !token) {
        this.$message("请先登录后再查看！");
      } else if (item.points == 0) {
        if (item.isVip === 1) {
          const dateNow = new Date().getTime();
          const effectiveDateTo = new Date(
            this.userInfo.effectiveDateTo
          ).getTime();
          if (dateNow > effectiveDateTo) {
            this.$message("会员已过期！");
          } else {
            // 登不登录都能看,有时间限制
            this.$router.push({
              name: this.toPath,
              params: {
                video_id: item.id,
                freeTime: item.freeTime,
                isVip: true,
              },
            });
          }
        } else {
          // // 免费
          this.$router.push({
            name: this.toPath,
            params: {
              video_id: item.id,
              isVip: false,
            },
          });
        }
      } else {
        // 扣积分看视频
        this.deductIntegral(item);
      }
    },
    //  扣积分函数
    async deductIntegral(item) {
      await getIntegralUrl({
        data: {
          type: "video",
          id: item.id,
        },
        success: (res) => {
          if (res.data) {
            // 是否会员
            if (item.isVip === 1) {
              // 登不登录都能看,有时间限制
              this.$router.push({
                name: this.toPath,
                params: {
                  video_id: item.id,
                  freeTime: item.freeTime,
                  isVip: true,
                },
              });
            } else {
              // // 免费
              this.$router.push({
                name: this.toPath,
                params: {
                  video_id: item.id,
                  isVip: false,
                },
              });
            }
          } else {
            this.$message(res.msg);
          }
        },
      });
    },
    // 导航栏
    getNavList() {
      getNavList({
        data: {
          position: 1,
        },
        success: (res) => {
          const indexCodeList = res.data[0].children;
          const noIndexList = res.data;
          noIndexList.forEach((item) => {
            if (item.label == "公告资讯") {
              this.columnCode1 = item.key;
            }
            if (item.label == "服务动态") {
              this.columnCode2 = item.key;
              localStorage.setItem("columnCode2", item.key);
            }
            if (item.model == "12") {
              // 学习充电哦
              this.getVideoCate();
              this.videoColumn = item.key;
            }
          });
          indexCodeList.forEach((item) => {
            if (item.label == "banner") {
              this.getIndexBanner(item.key);
            }
            if (item.label == "工作展示") {
              this.getWorkArea(item.key);
            }
            if (item.model == 6) {
              if (this.$phoneSize()) {
                if (item.label == "联系我们") {
                  this.getAWork(item.key, 4, item.label);
                } else {
                  this.getAWork(item.key, 1, item.label);
                }
              } else {
                if (item.label == "联系我们") {
                  this.getAWork(item.key, 4, item.label);
                } else {
                  this.getAWork(item.key, 3, item.label);
                }
              }
              // 联系我们统一变成4个
              // if (this.$phoneSize()) {
              // 	this.getAWork(item.key, 1, item.label)
              // } else {
              // 	if (item.label == '联系我们') {
              // 		this.getAWork(item.key, 7, item.label)
              // 	} else {
              // 		this.getAWork(item.key, 3, item.label)
              // 	}
              // }
            }
          });
        },
      });
    },
    // 获取视频分类
    async getVideoCate() {
      await getVideoCate({
        success: (res) => {
          // console.log("学习充电", res);
          this.lanmuList = res.data;
          if (res.data.length) {
            this.getVideoList(res.data[0].id);
          }
        },
      });
    },
    // 跳转新页面
    navToLink(link) {
      if (link) {
        window.open(link);
      }
    },
    // 首页工作展示
    async getWorkArea(column_code) {
      await getWorkArea({
        data: {
          column_code,
        },
        success: (res) => {
          this.soures_list = res.data;
        },
      });
    },
    // 获取首页banner
    getIndexBanner(columnCode) {
      getIndexBanner({
        data: {
          columnCode,
        },
        success: (res) => {
          this.bannerImgList = res.data.list;
        },
      });
    },
    // 首页奖项详情
    showIndexDetail(item) {
      if (item.url) {
        window.open(item.url);
      } else {
        if (this.$phoneSize()) {
          this.$router.push(`/phoneIndex/awardDetail/${item.id}`);
        } else {
          this.$router.push(`/awardDetail/${item.id}`);
        }
      }
    },

    // 入会须知等跳转
    fourNavTo(item, index) {
      if (this.$phoneSize()) {
        if (index == 0) {
          this.$router.push("/phoneIndex/admissionNotice");
        } else if (index == 1) {
          this.$router.push("/phoneIndex/register");
        } else if (index == 2) {
          this.$router.push("/phoneIndex/login");
        } else {
          this.$router.push("/phoneIndex/vipcheck");
        }
      } else {
        if (index == 0) {
          this.$router.push("/admissionNotice");
        } else if (index == 1) {
          this.$router.push("/register");
        } else if (index == 2) {
          this.$router.push("/login");
        } else {
          this.$router.push("/vipcheck");
        }
      }
    },

    async getAWork(columnCode, size, label) {
      await getNewAwork({
        data: {
          columnCode,
          pageSize: size,
        },
        success: (res) => {
          console.log("label", label);
          if (label == "精品展示") {
            // 精品工程
            console.log("精品展示", res);
            this.goodShops = res.data;
          } else {
            // 联系我们
            console.log("联系我们", res);
            this.contactList = res.data[0];
          }
        },
      });
    },
  },
};
</script>

<style scoped>
.serviceOut {
  display: flex;
  justify-content: space-between;
}
.serviceOut p {
  margin-right: 20px;
  cursor: pointer;
  line-height: 40px;
}
.servePaltorm {
  width: 32%;
  background-color: #fff;
  border-radius: 7px;
  overflow: hidden;
  transition: transform 0.3s;
  position: relative;
}
.servePaltorm:hover {
  cursor: pointer;
  transform: scale(1.05);
}
.servePaltorm_text {
  padding: 8px 10px;
  min-height: 95px;
  background-color: #fff;
}
.servePaltorm_text .p1 {
  font-size: 16px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.servePaltorm_text .p2 {
  margin: 5px 0;
  font-size: 14px;
  color: #999999;
}
.servePaltorm_live {
  position: absolute;
  bottom: 10px;
  right: 0px;
}
.webIndex_change img {
  width: 100%;
  height: 100%;
}

/* <768px */
@media screen and (max-width: 750px) {
  .leaderIndex {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 120px;
  }

  .leaderIndex img {
    margin: 20px;
    max-width: 100%;
  }

  :deep(.el-carousel__indicators) {
    display: none;
  }

  .webIndex_change {
    width: 70px;
    height: 70px;
    overflow: hidden;
    border-radius: 50%;
    text-align: center;
    line-height: 70px;
    position: fixed;
    color: #fff;
    right: 5px;
    bottom: 65px;
    z-index: 3333;
  }

  .newGrid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 5px;
    grid-row-gap: 5px;
  }

  .webIndex {
    width: 100%;
    padding-bottom: 60px;
  }

  .marginBot {
    margin-bottom: 30px;
  }

  .bgcc_zjx {
    margin: 20px 0;
    width: 100%;
    display: none;
  }

  .bgcc_zjx img {
    width: 100%;
    height: 100%;
  }

  .brumd_card {
    margin: 0px 0 20px 0;
    display: flex;
    flex-flow: column;
  }

  .zjxWarpList {
    width: 100%;
    height: 350px;
    background-color: #fff;
  }

  .active_meeting {
    margin: 0px 0 20px 0;
    display: flex;
    flex-flow: column;
  }

  .info_list_zjx {
    display: none;
    /* width: 100%;
			background-color: #fff; */
  }

  .zjxRightView {
    width: 100%;
    display: flex;
    flex-flow: column;
  }

  .zjxRightView_left {
    width: 100%;
  }

  .zjxRightView_Right {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-around;
  }

  .zjxRightView_Right__view p {
    font-size: 12px;
    margin-left: 7px !important;
  }

  .zjxRightView_Right__view {
    height: 55px;
    width: 24%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .zjxRightView_Right__view img {
    width: 22px;
    height: 22px;
  }

  .classFlex {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .classFlex_view {
    width: 100%;
    margin-bottom: 10px;
    cursor: pointer;
    position: relative;
  }

  .classFlex_view img {
    width: 100%;
    height: 139px;
    object-fit: cover;
    /* min-height: 139px; */
  }

  .classFlex_title {
    width: 100%;
    min-height: 70px;
    background-color: #fff;
  }

  .best_courses_p {
    min-height: 54px;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    line-height: 18px;
    font-weight: 400;
    padding: 7px 18px 0px;

    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  .view_father3 {
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
    justify-content: space-between;
  }

  .new_course_box {
    cursor: pointer;
    height: 80px;
    width: 100%;
    background-image: linear-gradient(180deg, #ffffff 0%, #feffff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
  }

  .course_box {
    cursor: pointer;
    height: 60px;
    width: 48%;
    background-image: linear-gradient(180deg, #ffffff 0%, #feffff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
  }

  .course_box img,
  .new_course_box img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }

  .course_box p,
  .new_course_box p {
    margin-left: 10px;
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 600;
  }

  .zjx_course_p {
    margin-left: 15px;
    font-family: PingFangSC-Semibold;
    font-size: 20px;
    color: #131415;
    letter-spacing: 0;
    font-weight: 600;
  }

  .grestProgrma_view {
    width: 100%;
  }

  .grestProgrma_view img {
    width: 100%;
    height: 232px;
    object-fit: cover;
  }

  .new_grestProgrma_view {
    width: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
    border: 1px solid rgba(219, 219, 219, 1);
    cursor: pointer;
    position: relative;
  }

  .new_grestProgrma_view img {
    width: 100%;
    max-height: 280px;
  }

  .grestProgrma_view p {
    display: inline-block;
    /* margin: 10px 0; */
    /* overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap; */
  }

  .new_grestProgrma_view p {
    display: inline-block;
    margin: 10px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .overSize {
    display: none !important;
  }

  .phoneSize {
    display: block;
  }

  .sepcilLandList {
    /* margin-left: 10px; */
    margin-top: -20px;
    height: 40px;
    margin-bottom: 10px;
  }

  .sepcilLandList p {
    display: inline-block;
    /* margin: 0 10px; */
    font-size: 16px;
    font-weight: 600;
  }

  .activeChoose {
    color: #c22c25;
  }

  .sepcilLandList p:hover {
    color: #c22c25;
    cursor: pointer;
  }

  .specil_title_p {
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    color: #131415;
    letter-spacing: 0;
    font-weight: 600;
    margin-left: 15px;
    text-align: center;
  }

  .specil_small_p {
    color: #c22c25 !important;
  }

  .sinfo_list_head p {
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    color: #131415;
    letter-spacing: 0;
    font-weight: 600;
    min-width: 100px;
    text-align: center;
    margin-left: 5px;
  }

  .versionDec {
    height: 148px;
    display: flex;
    flex-flow: column;
    width: 100%;
    padding: 14.33px 18px;
    box-sizing: border-box;
  }

  .versionDec span {
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    line-height: 26px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .versionDec p {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    text-align: left;
    line-height: 24px;
    font-weight: 400;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  .versionDec div {
    display: inline-block;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #d40d16;
    letter-spacing: 0;
    text-align: center;
    line-height: 18px;
    font-weight: 400;
    text-align: right;
    text-decoration: underline;
  }
}

@media screen and (min-width: 750px) {
  .leaderIndex {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }

  .leaderIndex img {
    margin: 20px;
    transition: 0.4s ease-in-out;
  }

  .leaderIndex img:hover {
    transform: scale(1.1);
    cursor: pointer;
  }

  .versionDec {
    height: 148px;
    display: flex;
    flex-flow: column;
    width: 380px;
    padding: 14.33px 18px;
    box-sizing: border-box;
  }

  .webIndex_change {
    cursor: pointer;
    width: 100px;
    height: 100px;
    overflow: hidden;
    border-radius: 50%;
    text-align: center;
    line-height: 70px;
    position: fixed;
    color: #fff;
    right: 50px;
    bottom: 50px;
    z-index: 3333;
  }

  .versionDec span {
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    line-height: 26px;
    font-weight: 600;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .versionDec p {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    text-align: left;
    line-height: 24px;
    font-weight: 400;

    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  .versionDec div {
    display: inline-block;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #d40d16;
    letter-spacing: 0;
    text-align: center;
    line-height: 18px;
    font-weight: 400;
    text-align: right;
    text-decoration: underline;
  }

  .webIndex {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }

  .newGrid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 20px;
  }

  .sinfo_list_head p {
    font-family: PingFangSC-Semibold;
    font-size: 20px;
    color: #131415;
    letter-spacing: 0;
    font-weight: 600;
    /* min-width: 100px; */
    text-align: center;
    margin-left: 19px;
  }

  .brund_cast {
    margin: 0px 0px 20px;
    display: flex;
  }

  .marginBot {
    margin-bottom: 30px;
  }

  .bgcc_zjx {
    margin: 20px 0;
  }

  .brumd_card {
    margin: 0px 0 20px 0;
    display: flex;
  }

  .zjxWarpList {
    width: 600px;
    height: 350px;
    background-color: #fff;
  }

  .info_list_zjx {
    width: 600px;
    background-color: #fff;
  }

  .active_meeting {
    margin: 0px 0 20px 0;
    display: flex;
    justify-content: space-between;
    height: 350px;
  }

  .zjxRightView {
    width: 590px;
    display: flex;
    justify-content: space-between;
  }

  .zjxRightView_left {
    width: 100%;
  }

  .zjxRightView_Right {
    width: 186px;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
  }

  .zjxRightView_Right__view {
    height: 80px;
    width: 186px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .zjxRightView_Right__view img {
    width: 34px;
    height: 30px;
  }

  .classFlex {
    display: flex;
    justify-content: space-between;
  }

  .classFlex_view {
    width: 280px;
    cursor: pointer;
    position: relative;
  }

  .classFlex_view > img {
    width: 280px;
    height: 156px;
    object-fit: cover;
  }

  .classFlex_title {
    width: 280px;
    height: 100px;
    background-color: #fff;
  }

  .best_courses_p {
    min-height: 51px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    line-height: 26px;
    font-weight: 400;
    padding: 7px 18px 0px;

    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .view_father3 {
    /* display: flex;
			flex-wrap: wrap;
			margin-top: 20px;
			justify-content: space-between; */
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 24px;
  }

  .course_box,
  .new_course_box {
    cursor: pointer;
    width: 280px;
    height: 80px;
    background-image: linear-gradient(180deg, #ffffff 0%, #feffff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    overflow: hidden;
  }

  .course_box img,
  .new_course_box img {
    width: 36px;
    height: 36px;
    border-radius: 50%;
  }

  .course_box p,
  .new_course_box p {
    width: 95px;
    margin-left: 30px;
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: 600;
  }

  .zjx_course_p {
    margin-left: 15px;
    font-family: PingFangSC-Semibold;
    font-size: 24px;
    color: #131415;
    letter-spacing: 0;
    font-weight: 600;
  }

  .new_grestProgrma_view {
    display: flex;
    flex-flow: column;
    align-items: center;
    border: 1px solid rgba(219, 219, 219, 1);
    cursor: pointer;
    position: relative;
  }

  .grestProgrma_view img {
    width: 380px;
    height: 232px;
    object-fit: cover;
  }

  .new_grestProgrma_view img {
    width: 165px;
    height: 140px;
  }

  /* .grestProgrma_view p {
			display: inline-block;
			margin: 10px 0;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			width: 270px;
		} */

  .new_grestProgrma_view p {
    display: inline-block;
    margin: 10px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .overSize {
    display: block;
  }

  .phoneSize {
    display: none !important;
  }

  .sepcilLandList {
    margin-left: 50px;
  }

  .sepcilLandList p {
    display: inline-block;
    margin: 0 20px;
    font-size: 18px;
    font-weight: 600;
  }

  /* 新版 sepcilLandList_new*/
  .sepcilLandList_new {
    display: flex;
    margin-left: 100px;
  }

  .sepcilLandList_new p {
    margin: 0 30px;
    font-family: PingFangSC-Regular;
    font-size: 20px;
    color: #7a7a7a;
    letter-spacing: 0;
    box-sizing: border-box;
    display: block;
    line-height: 51px;
    height: 51px;
    cursor: pointer;
  }

  .activeChoose {
    font-family: PingFangSC-Semibold;
    color: #d40d16 !important;
    font-weight: 600;

    /* color: #c22c25; */
    border-bottom: 3px solid #d40d16;
  }

  .sepcilLandList p:hover {
    color: #c22c25;
    cursor: pointer;
  }
}

.sinfo_list_head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.big_title_box {
  min-width: 100px;
  display: flex;
  height: 40px;
  line-height: 40px;
  padding-right: 10px;
}

.sinfo_list_head_span {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #d40d16;
  letter-spacing: 0;
  text-align: center;
  line-height: 40px;
  font-weight: 400;
  cursor: pointer;
  margin-right: 12px;
}

.best_courses_Span {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 18px 11px;
}

.normalFlex {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.courseFlex {
  height: 50px;
  justify-content: space-between;
  padding-right: 12px;
  /* border-bottom: 1px solid #D8D8D8; */
  margin: 30px 0;
}

.courseFlex_right {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #d40d16;
  letter-spacing: 0;
  text-align: center;
  line-height: 18px;
  font-weight: 400;
}

.courseFlex_right:hover {
  cursor: pointer;
  text-decoration: underline;
}

/* 精品课程 */
.best_courses_p__p1 {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #999999;
  letter-spacing: 0;
  text-align: left;
  font-weight: 400;
}

.best_courses_p__p2 {
  font-family: AlibabaPuHuiTi-Bold;
  font-size: 18px;
  color: #e02020;
  letter-spacing: 0;
  text-align: right;
  font-weight: 700;
}

.zjxheader {
  height: 100px;
  width: 100%;
  background-color: #c01219;
}

.zjxheader_center {
  width: 1200px;
  margin: 0 auto;
  height: 100px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.zjxheader_center__left {
}

.zjxheader_center__left_p {
  height: 50px;
  line-height: 50px;
  text-align: right;
  color: #fff;

  font-family: PingFangSC-Regular;
  font-size: 14px;
  letter-spacing: 0;
  font-weight: 400;
}

.zjxRightView_Right__view p {
  margin-left: 14px;
}

.zjxRightView_Right__view:nth-child(odd) {
  background-color: #d40d16;
}

.zjxRightView_Right__view:nth-child(even) {
  background-color: #c19b61;
}

.zjx_course_span_1 {
  display: inline-block;
  width: 8px;
  height: 30px;
  background: #d40d16;
}

.zjx_course_span_2 {
  margin-left: 5px;
  display: inline-block;
  width: 4px;
  height: 30px;
  background: #d40d16;
}

.grestProgrma {
  display: flex;
  justify-content: space-between;
}

.grestProgrma_view {
  display: flex;
  flex-flow: column;
  align-items: center;
  border: 1px solid rgba(219, 219, 219, 1);
  cursor: pointer;
  position: relative;
}
</style>
